<template>
  <div class="layout">
    <TopNavBar @handleItemClick="handleItemClick"></TopNavBar>
    <div class="main">
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <div class="showTheLogin"></div>
    <!-- 使用上下箭头组件 -->
    <div style="position: fixed; bottom: 320px; right: 50px; z-index: 99">
      <ScrollArrow />
    </div>
  </div>
</template>
<script>
import { isEmptyObject } from "@/utils/utils";
//引用头部组件 脚部组件  登录组件
import Footer from "@/components/Footer";
import TopNavBar from "@/components/NavBar";
import ScrollArrow from "@/components/ScrollArrow.vue";
export default {
  name: "layout",
  components: { TopNavBar, Footer, ScrollArrow },
  data() {
    return {};
  },
  mounted() {
    console.log('layout组件中打印',this.$route)
    // 添加路由完成后的监听器
    // this.routerAfterEach = this.$router.afterEach(() => {
    //   // 延迟执行，确保组件完全渲染
    //   setTimeout(() => {
    //     this.checkAndScrollToProductSection();
    //   }, 100);
    // });
  },
  watch: {
    // 监听路由对象的变化
    $route(to, from) {
      // to: 即将进入的路由对象
      // from: 即将离开的路由对象
      // 如果点击的是首页，并且to.query是空对向，禁止滚动‘
      // if (to.path === "/index" && isEmptyObject(to.query) && element == null) {
      //      // 滚动到该元素位置
      //     element.scrollIntoView({
      //       behavior: "smooth",
      //       top:0
      //     });
      // }
      // 可以在这里更新导航栏状态，如高亮当前菜单项
      // this.checkAndScrollToProductSection(to.path);
    },
  },
  methods: {
    handleItemClick(index) {
      console.log('布局组件获取', index)

    },
  },
};
</script>
<style scoped lang="scss">
.layout {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
  }
}
.hiddenLogin {
  animation: hiddenRight 1s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
@keyframes hiddenRight {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
</style>
